import { render, staticRenderFns } from "./ads-position-dialog.vue?vue&type=template&id=0cc90b68&"
import script from "./ads-position-dialog.vue?vue&type=script&lang=js&"
export * from "./ads-position-dialog.vue?vue&type=script&lang=js&"
import style0 from "./ads-position-dialog.vue?vue&type=style&index=0&id=0cc90b68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports